import React from 'react';
import { Box, useTheme } from '@mui/material';
import {
    ResponsiveContainer,
    LineChart,
    Line,
    YAxis,
    ReferenceLine,
} from 'recharts';

interface SparklineChartProps {
    data: number[];
    height?: number;
    color?: string;
    referenceValue?: number;
    fillOpacity?: number;
    gradient?: boolean;
}

const SparklineChart: React.FC<SparklineChartProps> = ({
    data,
    height = 40,
    color,
    referenceValue,
    fillOpacity = 0.2,
    gradient = true,
}) => {
    const theme = useTheme();
    const chartColor = color || theme.palette.primary.main;
    
    // Prepare data for chart
    const chartData = data.map((value, index) => ({ value, index }));

    return (
        <Box sx={{ width: '100%', height }}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={chartData}
                    margin={{ top: 4, right: 4, left: 4, bottom: 4 }}
                >
                    {gradient && (
                        <defs>
                            <linearGradient id="sparklineGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor={chartColor} stopOpacity={fillOpacity} />
                                <stop offset="95%" stopColor={chartColor} stopOpacity={0} />
                            </linearGradient>
                        </defs>
                    )}

                    {referenceValue !== undefined && (
                        <ReferenceLine
                            y={referenceValue}
                            stroke={theme.palette.divider}
                            strokeDasharray="3 3"
                        />
                    )}

                    <YAxis domain={['auto', 'auto']} hide />

                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke={chartColor}
                        strokeWidth={1.5}
                        dot={false}
                        activeDot={false}
                        isAnimationActive={false}
                        fill={gradient ? "url(#sparklineGradient)" : "none"}
                    />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default SparklineChart; 